import { API_BASE, request } from './http'
import type { Box, PageSize, RectMM } from '@/lib/diegeticGeometry'

export interface PagePanel { id: string; rect_mm: RectMM; asset_id: string }
export interface DiegeticText {
  id: string
  panel_id: string
  carrier: string
  carrier_box: Box | null
  rect_mm: RectMM
  font_size_mm: number
  text: string
  style: string
  placement: 'vlm' | 'manual' | 'fallback_safe_area'
}
export interface PageIR {
  page: PageSize & { dpm: number }
  panels: PagePanel[]
  diegetic_texts?: DiegeticText[] | null
}
export interface CarrierIdentity { panel_image_asset_id: string; carrier: string }
export type DiegeticOverride = CarrierIdentity & Box

export interface PagePreviewItem {
  asset_id: string
  page_index: number
  page_count: number
  layout_mode: string
  fallback: boolean
  fallback_reason: string
  degraded: string[]
  panel_count: number
  // 后端在列表里直接给出条数, 使前端不必为每页拉取完整 page_ir 才知道能不能编辑。
  diegetic_count: number
}

// 🔴 路径遵循仓库唯一约定 /v1/chapters/{id}/... —— 与 av-compose 的 /v1/chapters/{id}/compose 同形。
// 章节 ID 全局唯一, 归属由后端 ChapterOwnerMiddleware 保证, 故不需要 project 段。
function chapterPath(chapterId: string) {
  return `/v1/chapters/${encodeURIComponent(chapterId)}`
}

export const pagePreviewApi = {
  preflight: (chapterId: string) => request<{ready: boolean; missing: string[]}>(`${chapterPath(chapterId)}/page-compose/preflight`),
  list: (chapterId: string) => request<PagePreviewItem[]>(`${chapterPath(chapterId)}/pages`),
  ir: (chapterId: string, assetId: string) => request<PageIR>(`${chapterPath(chapterId)}/pages/${encodeURIComponent(assetId)}/ir`),
  putOverride: (chapterId: string, body: DiegeticOverride) => request<void>(`${chapterPath(chapterId)}/diegetic-overrides`, { method: 'PUT', body }),
  deleteOverride: (chapterId: string, body: CarrierIdentity) => request<void>(`${chapterPath(chapterId)}/diegetic-overrides`, { method: 'DELETE', body }),
  compose: (chapterId: string) =>
    request<{ job_id: string; status: string }>(`${chapterPath(chapterId)}/page-compose`, { method: 'POST' }),
  imageUrl: (chapterId: string, assetId: string) =>
    `${API_BASE}${chapterPath(chapterId)}/pages/${encodeURIComponent(assetId)}/image`,
}
